import { Api, IConfig } from 'elc-service';
import { root, BrowserStorage } from 'elc-universal-utils';

const API_HOST_COOKIE = 'ELC_API_HOST';
const API_AUTH_COOKIE = 'ELC_API_AUTH';
const REV_TAG_COOKIE = 'ELC_SITE_TAG';
const LOCALHOST = 'localhost';
const AUTOTEST_DOMAIN = 'api.elco.cloud';
const MOBILE_CHANNEL = 'mobile';

export interface IDrupalDefaultHeaders {
    Authorization?: string;
    Host?: string;
}

interface IDrupalAPIFetch {
    url: string;
    headers?: {};
}

export class DrupalApi extends Api {
    protected apiHost: string;
    protected channel: string;
    protected revTag: string;
    protected static drupalDomain: string;

    constructor(config: IConfig) {
        super(config);
        DrupalApi.drupalDomain = config.drupalDomain || '';
        this.apiHost = DrupalApi.getApiHost();
        this.channel = DrupalApi.getChannel();
        this.revTag = DrupalApi.getRevTag();
    }

    protected fetch = async <T>({ url, headers = {} }: IDrupalAPIFetch) => {
        const combinedHeaders = {
            ...DrupalApi.getHeaders(),
            ...headers
        };

        if (DrupalApi.useApiCookies() && (!DrupalApi.getApiHost() || !DrupalApi.getApiAuth())) {
            DrupalApi.displayMessages();

            return { data: {}, headers: null };
        }

        return this.httpTransport.get<T>(
            {
                url,
                headers: combinedHeaders
            },
            { debounceInterval: 100 }
        );
    };

    private static displayMessages(): void {
        console.warn(
            '%cATTENTION!',
            'font-weight: bold; font-size: 50px; color: red; text-shadow: 3px 3px 0 rgb(217,31,38), 6px 6px 0 rgb(226,91,14), 9px 9px 0 rgb(245,221,8), 12px 12px 0 rgb(5,148,68), 15px 15px 0 rgb(2,135,206), 18px 18px 0 rgb(4,77,145), 21px 21px 0 rgb(42,21,113)'
        );
        console.warn(
            `%cDrupalApi: %cmissing ${API_HOST_COOKIE} and/or ${API_AUTH_COOKIE} cookies (elc-drupal-api)`,
            'font-weight: bold',
            'font-weight: normal'
        );
    }

    private static isLocalhost(): boolean {
        return <Location>root.location && root.location.hostname.indexOf(LOCALHOST) > -1;
    }

    private static isAutotest(): boolean {
        return <Location>root.location && root.location.hostname.indexOf(AUTOTEST_DOMAIN) > -1;
    }

    private static useApiCookies(): boolean {
        return (DrupalApi.isLocalhost() || DrupalApi.isAutotest()) && !DrupalApi.drupalDomain;
    }

    private static getHeaders(): IDrupalDefaultHeaders {
        const headers: IDrupalDefaultHeaders = {};

        if (DrupalApi.getApiAuth()) {
            headers.Authorization = `Basic ${Buffer.from(DrupalApi.getApiAuth()).toString(
                'base64'
            )}`;
        }

        return headers;
    }

    private static getApiHost(): string {
        const host = BrowserStorage.getCookie(API_HOST_COOKIE);

        return DrupalApi.useApiCookies() && !!host ? host : '';
    }

    private static getApiAuth(): string {
        const auth = BrowserStorage.getCookie(API_AUTH_COOKIE);

        return DrupalApi.useApiCookies() && !!auth ? auth : '';
    }

    private static getChannel(): string {
        return <Location>root.location && root.location.host.search(/m[tmp]*\./) > -1
            ? MOBILE_CHANNEL
            : '';
    }

    private static getRevTag(): string {
        const revisionTag = BrowserStorage.getCookie(REV_TAG_COOKIE);

        return !!revisionTag ? revisionTag : '';
    }
}
